import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import posthog from "posthog-js";
import "./index.css";
import App from "./App";
import { installDemoFetchPatch } from "./utils/demoFetchPatch";

// Demo mode (main_admin "Switch as Demo"): masks person/org names in API
// responses so a sales demo can run on a real org without exposing identities.
// Installed before render so no request escapes it. Inert unless the flag is
// set — a normal switch is unaffected.
installDemoFetchPatch();

// Benign browser notice, not a real exception: ResizeObserver fires it when a
// resize callback itself causes another layout pass in the same frame (charts
// inside width-animating drawers do this). Only the webpack dev overlay
// escalates it to a blocking "Uncaught runtime error". Capture-phase listener
// runs before the overlay's, so we can swallow exactly this message and
// nothing else.
const RESIZE_OBSERVER_NOISE = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener(
  "error",
  (e) => {
    if (e.message && RESIZE_OBSERVER_NOISE.some((m) => e.message.includes(m))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

// person_profiles: without it no person profile is created, so posthog.identify()
// in AuthContext was a no-op — every event landed anonymous (verified: 0 persons
// against 38k pageviews). 'identified_only' keeps anonymous visitors cheap (marketing
// pages stay profile-less) while creating a profile the moment a user logs in, which
// is what lets main_admin see per-org and per-user behaviour.
posthog.init(process.env.REACT_APP_POSTHOG_KEY || "YOUR_POSTHOG_API_KEY", {
  api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
  capture_pageview: false,
  capture_pageleave: true,
  autocapture: true,
  person_profiles: "identified_only",
});

const rootElement = document.getElementById("root");
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}
